import React,{useContext, useState} from 'react';
import styles from './addPost.module.css';
import {AiOutlineCamera,AiOutlineArrowLeft} from 'react-icons/ai'
import {RiVideoAddLine} from 'react-icons/ri'
import {BiImageAdd} from 'react-icons/bi'
import { Link } from 'react-router-dom';
import { NavIconContext } from '../../../context/NavIconContext';



const AddPost =()=>{

    const {setAddpost}=useContext(NavIconContext);

    return(
               <div className={styles.iconCon}>
                   <Link onClick={()=>setAddpost(false)} to="/Post_Image" > 
                    <BiImageAdd className={styles.addIcon} />
                    </Link>
                    
                    <RiVideoAddLine className={styles.addIcon} />
                      
        </div>
    )
}

export default AddPost